import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type GetPayoutDetailsQuery} from './__generated__/queries.api-types';

const domain = 'MODALS/PAYOUT_DETAILS';

export const {action: show} = createAction(`${domain}/SHOW`, (payoutId: string) => ({payoutId}));

export const {action: showWithPrefetched} = createAction(
    `${domain}/SHOW_WITH_PREFETCHED`,
    (
        prefetchedPayout: GetPayoutDetailsQuery['payments']['getPayout'],
        overrideTitle?: string,
        explanation?: string,
    ) => ({prefetchedPayout, overrideTitle, explanation}),
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
